import gql from 'graphql-tag'

export default gql`mutation go($data: UserScheduleInput!){
  upsert_user_schedule(data: $data){
    id
      user_id
      start_date
      end_date
      user_schedule_type_id
      active
      project_activity_budget_id
      project_activity_budget{
        id
        project_id
        project{
          name
        }
        description
        stage
        address{
          full_address
        }
      }
      user_project_activities{
        user_schedule_id
        user_project_activity_id
        project_id
        project{
          name
        }
        project_activity_budget_id
        project_activity_budget{
          id
          description
          stage
          address{
            full_address
          }
        }
      }
  }
}`